// ─── Pokémon TCG Client ───────────────────────────────────────────
// Calls /api/card-search serverless endpoint
// All multi-source logic is server-side

const API_BASE = "/api/card-search";

export const POKEMON_LANGUAGES = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "ja", label: "Japanese", flag: "🇯🇵" },
  { code: "pt", label: "Português", flag: "🇧🇷" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
];

let currentLang = "en";
export function setPokemonLang(lang) { currentLang = lang || "en"; }
export function getPokemonLang() { return currentLang; }

async function fetchAPI(params) {
  const qs = new URLSearchParams({ ...params, lang: currentLang }).toString();
  try {
    const res = await fetch(`${API_BASE}?${qs}`);
    if (!res.ok) return null;
    return res.json();
  } catch { return null; }
}

function normalize(raw) {
  const nameLocal = raw.name_local;
  const nameEn = raw.name_en || raw.name || "";
  const displayName = (nameLocal && nameLocal !== nameEn)
    ? `${nameEn} (${nameLocal})`
    : nameEn;

  return {
    id: `pkmn-${raw.id}`,
    api_id: raw.id,
    name: displayName,
    name_en: nameEn,
    name_local: nameLocal || null,
    game: "pokemon",
    set_name: raw.set_name || "",
    set_code: raw.set_code || "",
    card_number: raw.card_number || "",
    rarity: raw.rarity || "Unknown",
    variant: raw.supertype || "Pokémon",
    lang: currentLang,
    image_url: raw.image_url || "",
    image_small: raw.image_small || "",
    slug: `${nameEn.toLowerCase().replace(/\s+/g, "-")}-${raw.set_code}-${raw.card_number}`,
    supertype: raw.supertype,
    hp: raw.hp,
    types: raw.types || [],
    artist: raw.artist || "",
    tcgplayer_url: raw.tcgplayer_url || "",
    tcgplayer_prices: raw.tcgplayer_prices || null,
    cardmarket_prices: raw.cardmarket_prices || null,
  };
}

export async function searchPokemonCards(query, page = 1, pageSize = 48) {
  const data = await fetchAPI({ q: query, type: "search", page, pageSize });
  if (!data || !data.cards) return { cards: [], totalCount: 0, page, pageSize };
  return {
    cards: data.cards.map(normalize),
    totalCount: data.totalCount || data.cards.length,
    page: data.page || page,
    pageSize,
  };
}

export async function getPokemonCardById(apiId) {
  const data = await fetchAPI({ q: apiId, type: "search", pageSize: 1 });
  if (!data || !data.cards || data.cards.length === 0) return null;
  return normalize(data.cards[0]);
}

export async function getPokemonSets() {
  const data = await fetchAPI({ type: "sets" });
  if (!data || !data.sets) return [];
  return data.sets.map((s) => ({
    id: s.id,
    name: s.name_en || s.name,
    name_en: s.name_en || s.name,
    name_local: s.name_local || null,
    series: s.series || "",
    total: s.total || 0,
    releaseDate: s.releaseDate || "",
    isExclusive: false,
    images: { symbol: s.symbol || "", logo: s.logo || "" },
  }));
}

export async function getPokemonCardsBySet(setId, page = 1, pageSize = 250) {
  const data = await fetchAPI({ type: "set_cards", set_id: setId });
  if (!data || !data.cards) return { cards: [], totalCount: 0, page, pageSize };
  return {
    cards: data.cards.map(normalize),
    totalCount: data.totalCount || data.cards.length,
    page: 1,
    pageSize: data.cards.length,
  };
}
